<template>
  <div class="feed-media flex">
    <div class="audio-icon-wrap">
      <img src="../../../assets/image/cl_music_icon.png" />
    </div>
    <div class="audio-tag-wrap">
      <audio controls>
        <source :src="feed.uriKey[0]" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</template>
<script>
export default {
  name: "article-element",
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
.audio-icon-wrap {
  height: 35px;
  margin-right: 10px;
}

.audio-icon-wrap img {
  height: 100%;
}

.audio-tag-wrap audio {
  width: 350px;
  height: 35px;
  border-radius: 3px;
  background-color: #f2f2f2 !important;
}
</style>